module.exports = __webpack_public_path__ + "16afdabea8e2dc4c0c90b2d9c3495b15.svg";